<div class="tabs">
  <div class="tab-buttons">
    <p *ngFor="let tab of tabs; let i = index" class="mb-0" [class.active]="tab.active" (click)="selectTab(i)">
      {{ tab.title }}
    </p>
  </div>
  <ng-content></ng-content>
</div>
